<template>
  <div
    id="login-html"
    class="login-html">
    <!-- <div class="login-blur"/> -->
    <div class="container-login">
      <div class="login-box">
        <div class="align-center">
          <img
            src="../../assets/image/logo-login.png"
            class="logo-login">
        </div>
        <div class="label-top">Sistem Informasi Manajemen Sekolah</div>
        <div class="label-bottom">SMKN 1 Majalengka</div>

        <div class="label-signin">Sign In</div>
        <b-form
          @reset="onReset"
          @keyup.enter="onSubmit">
          <b-form-group>
            <b-form-input
              id="exampleInput1"
              :class="{'error-input' : $v.form.username.$error}"
              :error-message="null"
              :placeholder="'Kode Pegawai'"
              v-model="$v.form.username.$model"/>
          </b-form-group>
          <b-form-group id="exampleInputGroup2">
            <b-form-input
              id="exampleInput2"
              :type="password_id"
              :error-message="null"
              :class="{'error-input' : $v.form.password.$error}"
              v-model="$v.form.password.$model"
              placeholder="Password"/>
          </b-form-group>
          <b-form-checkbox v-model="show_pass">show password</b-form-checkbox>
          <div
            class="btn-login"
            @click="onSubmit">
            Login
          </div>
          <div class="copy-right">Copyright © 2021 NextDev</div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>

import { required, minLength } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  name: 'JLogin',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      show_pass: false,
    };
  },
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
  },
  methods: {
    ...mapActions('jStoreLogin', ['loginAccountSiswa']),
    onSubmit() {
      this.$v.form.$touch();
      if (!this.form.username.match(/^[A-Za-z0-9@.]+$/g)) {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Please input kode pegawai correctly');
      } else if (!this.$v.form.$error) {
        this.loginAccountSiswa(this.form);
      }
    },
    onReset() {
      this.form.username = '';
      this.form.password = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/login-siswa/jLoginSiswa.vue